import React from 'react'
import { Route, Routes } from "react-router-dom";
import VehicleFuelCreateScreen from "screens/App/CRM/VehicleFuel/VehicleFuelCreateScreen";
import VehicleFuelDetailScreen from "screens/App/CRM/VehicleFuel/VehicleFuelDetailScreen";
import VehicleFuelEditScreen from "screens/App/CRM/VehicleFuel/VehicleFuelEditScreen";
import VehicleFuelListScreen from "screens/App/CRM/VehicleFuel/VehicleFuelListScreen";



const VehicleFuelRouter = () => {
    return (
        <Routes>
            <Route path="list" element={<VehicleFuelListScreen />} />

             <Route path="create" element={<VehicleFuelCreateScreen />} />

             <Route path=":id/edit" element={<VehicleFuelEditScreen />} />

            <Route path=":id/detail" element={<VehicleFuelDetailScreen />} />

        </Routes>
    )
}

export default VehicleFuelRouter